export default __webpack_public_path__ + "4751f00.png";